import * as addressAnalysisFeign from './addressAnalysisFeign';
import * as afterSaleServiceFeign from './afterSaleServiceFeign';
import * as afterSaleStore from './afterSaleStore';
import * as area from './area';
import * as pageBanner from './pageBanner';
import * as storeActivity from './storeActivity';
import * as storeApi4ThirdParty from './storeApi4ThirdParty';
import * as storeClueRpcFeign from './storeClueRpcFeign';
import * as storeControllerV3 from './storeControllerV3';
import * as storeControllerV4 from './storeControllerV4';
import * as storeFeedbackApi from './storeFeedbackApi';
import * as storeFeedbackRefactorApi from './storeFeedbackRefactorApi';
import * as storeInfoFeign from './storeInfoFeign';
import * as storeNews from './storeNews';
import * as storeProcessFeign from './storeProcessFeign';
import * as storeReviewApi from './storeReviewApi';
import * as userOrderRecord from './userOrderRecord';

export const store = {
  addressAnalysisFeign,
  afterSaleServiceFeign,
  afterSaleStore,
  area,
  pageBanner,
  storeActivity,
  storeApi4ThirdParty,
  storeClueRpcFeign,
  storeControllerV3,
  storeControllerV4,
  storeFeedbackApi,
  storeFeedbackRefactorApi,
  storeInfoFeign,
  storeNews,
  storeProcessFeign,
  storeReviewApi,
  userOrderRecord,
};
